import React from 'react';
import styled from '@emotion/styled';

import Layout from 'layout/Layout';

const About = () => {
  return (
    <Layout>
      <AboutStyled>About</AboutStyled>
    </Layout>
  );
};

const AboutStyled = styled.div`
  width: 100%;

  background-color: #f1f1f1;

  padding: 20px 0 0 20px;
`;

export default About;
